import { Space, Typography } from 'antd';

interface Props {
  children: React.ReactNode;
  title: string;
  className?: string;
}

export function TitledSection(props: Props) {
  const { children, title, className } = props;
  return (
    <Space direction="vertical" size="large" className={className}>
      <Typography.Title level={4}>{title}</Typography.Title>
      {children}
    </Space>
  );
}
